import { render, staticRenderFns } from "./OldPenaltyForm.vue?vue&type=template&id=730191a8"
import script from "./OldPenaltyForm.vue?vue&type=script&lang=js"
export * from "./OldPenaltyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports